export * as Api from './api';

export enum TagName {
  Direct = 'Direct',
  VCT = 'VCT',
  LP = 'LP',
}

export enum TagTaxReliefType {
  EIS = 'EIS',
  SEIS = 'SEIS',
  VCT = 'VCT',
  KI = 'EIS (KI)',
}
